export default "__VITE_ASSET__BTqrLucj__"